import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { capturingCurrentStateState } from '../../../storage/streaming';
import CurrentStateSharedMarker from './CurrentStateSharedMarker';

function CapturingVideoMarker() {
  const currentState = useRecoilValue(capturingCurrentStateState);

  if (!currentState || (!currentState.asset.vehicle && !currentState.asset.assetType)) return null;

  return <CurrentStateSharedMarker currentState={currentState} />;
}

export default memo(CapturingVideoMarker);
